import { render, staticRenderFns } from "./PageHeaderNavButton.vue?vue&type=template&id=36c163a1&scoped=true"
import script from "./PageHeaderNavButton.js?vue&type=script&lang=js&external"
export * from "./PageHeaderNavButton.js?vue&type=script&lang=js&external"
import style0 from "./PageHeaderNavButton.scss?vue&type=style&index=0&id=36c163a1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c163a1",
  null
  
)

export default component.exports